import React, { useState } from 'react';
import { emptyDatesObject } from '../../../../../availability_calendar/AvailabilityCalendar';
import { getStartDateForFilter } from '../../stats/utils/statsHelpers';
import dayjs from 'dayjs';
import { Button, Popover, Select } from 'antd';
import Icon, { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { DateRangePicker } from 'react-date-range';
import SvgDateRangePicker from '../../../../../admin/assets/images/Dashboard/DateRangePicker';

const dateRangeFilters = [
  { value: 'today', label: 'Today' },
  { value: 'yesterday', label: 'Yesterday' },
  { value: 'week', label: 'Last 7 Days' },
  { value: 'month', label: 'Month-to-date' },
  { value: 'last_month', label: 'Last 30 Days' },
  { value: 'all', label: 'All Time' },
  { value: 'custom', label: 'Custom' },
];

export default function StatsDateRangeSelect({
  initialValue = 'today',
  onDatesChange,
  showAllTime = false,
}) {
  const [selected, setSelected] = useState(
    initialValue ?? dateRangeFilters[0].value
  );
  const [customDates, setCustomDates] = useState([{ ...emptyDatesObject }]);
  const [showFilterCalendar, setShowFilterCalendar] = useState(false);

  const handleFilterSelection = (value) => {
    setSelected(value);
    if (value === 'custom') {
      setShowFilterCalendar(Boolean(value === 'custom'));
    } else {
      onDatesChange({ start: getStartDateForFilter(value), end: dayjs() });
    }
  };

  return (
    <>
      <Popover
        open={showFilterCalendar}
        onOpenChange={setShowFilterCalendar}
        trigger='none'
        placement='bottomRight'
        content={
          <>
            <div className='row-right'>
              <Button
                icon={<CloseOutlined />}
                type='text'
                onClick={() => setShowFilterCalendar(false)}
              />
            </div>
            <div className='grid-center' id='filter-date-range'>
              <DateRangePicker
                onChange={(item) => {
                  setCustomDates([item.selection]);
                  onDatesChange({
                    start: dayjs(item.selection.startDate),
                    end: dayjs(item.selection.endDate),
                  });
                }}
                months={2}
                ranges={customDates}
                direction='horizontal'
                color='black'
                rangeColors={['black', 'white']}
              />
            </div>
          </>
        }
      >
        <Select
          options={dateRangeFilters.filter(
            (e) => showAllTime || e?.value !== 'all'
          )}
          value={selected}
          className='date-range-selector gSemiBold fs-16'
          popupClassName='date-range-selector__list gRegular'
          onSelect={(value) => handleFilterSelection(value)}
          dropdownMatchSelectWidth={false}
          placement='bottomRight'
          bordered={false}
          suffixIcon={
            <Icon
              component={() => <SvgDateRangePicker />}
              className='gSemiBold black fs-18 pd-left-20'
              style={{
                pointerEvents: 'none' /* Allows icon to be selectable */,
              }}
            />
          }
          menuItemSelectedIcon={<CheckOutlined />}
        />
      </Popover>
    </>
  );
}
